import Vue from 'vue'
import { clone } from 'ramda'
import equal from 'fast-deep-equal'
import TreeSelectorComponent from '@/components/commons/tree-selector/TreeSelectorComponent.vue'
import { mapActions } from 'vuex'

export default {
    name: 'AlertEventDialogThingsTabComponent',
    components: {
        TreeSelectorComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules:{
            type: Object,
            required: true
        },
        validForm:{
            type: Boolean,
            required: true
        },
        resetFormValidation:{
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
        // search del treeview
        search: null,
        // selector de cosas
        selected: [],
        // últimos elementos seleccionados clonados (para evitar recursividad infinita en la función selectedChanged)
        lastSelectedCloned: null,
        // loading del selector de cosas
        loading:  false,
    }),
    computed: {
    },
    created () {
    },
    mounted () {
        this.initialize()
    },
    methods: {
        /**
         * Obtiene la estructura anidada de empresas -> grupos -> equipos
         */
         initialize () {
            // expando el treeview
            const that = this
            Vue.nextTick(function () {
                that.expandCollapse(true)
            })
        },
        /**
         * Expande / colapsa el árbol
         * @param {*} value
         */
        expandCollapse (value) {
            this.$refs.thingAssignmentTreeview.updateAll(value)
        },
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pushBread'
        ]),
        /**
         * Cuando cambian los nodos seleccionados, ejecuto una función para eliminar de la selección
         * otros nodos que no corresponden:
         * - Cuando selecciono un hijo, el padre no debe estar seleccionado;
         * - Cuando selecciono un padre, los hijos no deben estar seleccionados.
         * De esta forma, no hay datos redundantes, por ejemplo, que una empresa esté en el arreglo userEnterprises
         * y todas las cosas estén en el arreglo userThings
         */
         selectedChanged (nodes) {
            const that = this
            Vue.nextTick(function () {
                that.selected.cleanAndUpdate(nodes)
                // valido que haya cambiado el arreglo de elemento seleccionados, para evitar recursividad infinita
                if (that.lastSelectedCloned != null && !equal(that.lastSelectedCloned, that.selected)) {
                    that.loading = true
                    // invierto el orden porque los elementos seleccionados más recientemente están en el final del arreglo
                    const selectedCloned = clone(that.selected)
                    that.lastSelectedCloned = selectedCloned
                    const reverseSelected = selectedCloned.reverse()
                    // por cada elemento, verifico si hay que eliminar padres o hijos
                    let index;
                    let flag;
                    reverseSelected.forEach(element => {
                        switch (element.nodeType) {
                            case 'THING':
                                // empresa
                                if (element.enterpriseId != null) {
                                    index = selectedCloned.findIndex(item => item.id === element.enterpriseId)
                                    if (index > -1) {
                                        selectedCloned.splice(index, 1)
                                    }
                                }
                                // grupo
                                if (element.groupId != null) {
                                    index = selectedCloned.findIndex(item => item.id === element.groupId)
                                    if (index > -1) {
                                        selectedCloned.splice(index, 1)
                                    }
                                }
                                break;
                            case 'GROUP':
                                // empresa
                                if (element.enterpriseId != null) {
                                    index = selectedCloned.findIndex(item => item.id === element.enterpriseId)
                                    if (index > -1) {
                                        selectedCloned.splice(index, 1)
                                    }
                                }
                                // cosas
                                flag = false
                                while (!flag) {
                                    index = selectedCloned.findIndex(item => item.groupId === element.id)
                                    if (index > -1) {
                                        selectedCloned.splice(index, 1)
                                    } else {
                                        flag = true
                                    }
                                }
                                break;
                            case 'ENTERPRISE':
                                // grupos y cosas
                                flag = false
                                while (!flag) {
                                    index = selectedCloned.findIndex(item => item.enterpriseId === element.id)
                                    if (index > -1) {
                                        selectedCloned.splice(index, 1)
                                    } else {
                                        flag = true
                                    }
                                }
                                break;
                            default:
                                console.error('Tipo de nodo de la lista de cosas anidadas en grupos y empresas desconocido')
                                break;
                        }
                    })
                    that.selected = clone(selectedCloned)
                    that.loading = false
                }
                // filtrar selected
                const result = []
                that.selected.forEach(element => {
                        if(element.nodeType == 'ENTERPRISE') 
                            element.children.forEach(el => {
                                if (el.nodeType == 'GROUP')
                                    el.children.forEach(e => {
                                        result.push(e.id)
                                    })
                                else if (el.nodeType == 'THING')
                                    result.push(el.id) 
                            })
                        else if(element.nodeType == 'GROUP') 
                            element.children.forEach(el => {
                                result.push(el.id)
                            }) 
                        else if(element.nodeType == 'THING') 
                            result.push(element.id) 
                })
                that.model.thingIdsResult.cleanAndUpdate(result)                
                that.model.thingIdsResult.length > 0 ? that.isValidForm = true : that.isValidForm = false; 
            })
            
        }
    },
    watch: {
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
         isValidForm(newVal, oldVal) {
            if (newVal!==oldVal) {
                this.model.thingIdsResult.length > 0 ? this.isValidForm = true : this.isValidForm = false; 
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal) {
                if (this.$refs.alertEventDialogThingsTabComponent) {
                    this.$refs.alertEventDialogThingsTabComponent.resetValidation()
                }
            }
        },
        /**
         * Búsqueda en el treeview de equipos asignados
         * @param {*} newVal
         */
        search (newVal) {
            if (newVal) {
                this.$refs.thingAssignmentTreeview.updateAll(true)
            }
        },
        'model.thingIds':{
            deep: true,
            immediate: true,
            handler: function (newSelectedData) {
                this.selected = clone(newSelectedData)
                this.lastSelectedCloned = clone(this.selected)
            }
        }
    }
}
